import React, { useCallback } from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { LegalProps } from './models';
import { useTranslation } from '@sunbit-dev/translations';
import { StyledLink } from '@sunbit-dev/web-ui-lib';
import URLs, { InfoURLs } from '~/enums/URLs';
import { useHistory, useLocation } from 'react-router-dom';
import { LinksTestIds } from '~/enums/TestIds';

export const Legal = styled(({ showAsterisk, className }: LegalProps) => {
  const { t } = useTranslation('landing_page', { keyPrefix: 'legal' });
  const history = useHistory();
  const { search } = useLocation();

  const onRatesAndTermsClick = useCallback(() => {
    history.replace({ pathname: [URLs.Info, InfoURLs.RatesAndTerms].join(''), search });
  }, [history, search]);

  return (
    <div className={className}>
      <p className="text">
        {(showAsterisk ? '*' : '') + t('first_section')}
        <StyledLink
          className="rates-and-terms-link"
          data-testid={LinksTestIds.RatesAndTerms}
          onClick={onRatesAndTermsClick}
        >
          {t('rates_and_terms')}
        </StyledLink>
        {t('second_section')}
      </p>
    </div>
  );
})`
  ${styles.Legal}
`;
